import React, { useState } from "react";

import Filter from "./Filter";
import Sort from "./Sort";
type Props = {
  filters: {
    jobs?: object;
    sectors?: object;
    pslSectors?: object;
    employer_users?: object;
    agencies?: object;
    timeframe?: string[];
    sortOrder?: string;
    sortBy?: object;
  };
  // loadJobPerformance: (filterData?: object) => void;
  filterAction: any;
  analyticsFilter: any;
  resetDefaultFilters: any;
  resetDateRangeFilter: any;
};

export const FilterAndSort = (props: Props) => {
  const {
    filters,
    filterAction,
    analyticsFilter,
    resetDefaultFilters,
    resetDateRangeFilter,
  } = props;
  const initialValue = {
    jobs: [],
    job_sectors: [],
    pslSectors: [],
    employer_users: [],
    timeframe: ["Last 12 Months"],
    agencies: [],
    sortOrder: "desc",
    sortBy: ["jobs_total_filled"],
  };
  const [dataFilters, setDataFilters] = useState(initialValue);

  return (
    <>
      <Filter
        dataFilters={dataFilters}
        setDataFilters={setDataFilters}
        filters={filters}
        filterAction={filterAction}
        analyticsFilter={analyticsFilter}
        resetDefaultFilters={resetDefaultFilters}
        resetDateRangeFilter={resetDateRangeFilter}
      />
      {filters.sortOrder && (
        <Sort
          dataFilters={dataFilters}
          setDataFilters={setDataFilters}
          filters={filters}
          filterAction={filterAction}
          analyticsFilter={analyticsFilter}
          resetDefaultFilters={resetDefaultFilters}
        />
      )}
    </>
  );
};

export default FilterAndSort;
